import { ElementRef } from "@angular/core";
import { Rating } from '../model/rating.model';
import { RatingService } from '../../entities/rating/rating.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { JhiLanguageService } from '../../ng-jhipster/language';
import { JhiEventManager } from '../../ng-jhipster/service';
import { Router } from "@angular/router";
import * as i0 from "@angular/core";
import * as i1 from "../../entities/rating/rating.service";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "../../ng-jhipster/service";
import * as i4 from "@angular/router";
import * as i5 from "../../ng-jhipster/language";
import * as i6 from "@fortawesome/angular-fontawesome";
import * as i7 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i8 from "@angular/common";
import * as i9 from "@angular/forms";
import * as i10 from "../auto-direction-switch/input-auto-direction-switch.directive";
import * as i11 from "@ngx-translate/core";
const _c0 = ["ratingAlertModal"];
const _c1 = function (a0) { return { "rating-star-hover": a0 }; };
function RateSessionComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "fa-icon", 21);
    i0.ɵɵlistener("click", function RateSessionComponent_div_11_Template_fa_icon_click_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r7); const i_r5 = restoredCtx.index; const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.highlightStarCoach($event, i_r5); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r5 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c1, i_r5 <= ctx_r0.maxHighLightIndexCoach));
} }
function RateSessionComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "fa-icon", 21);
    i0.ɵɵlistener("click", function RateSessionComponent_div_17_Template_fa_icon_click_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r11); const i_r9 = restoredCtx.index; const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.highlightStarApp($event, i_r9); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r9 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c1, i_r9 <= ctx_r1.maxHighLightIndexApp));
} }
function RateSessionComponent_ng_template_25_h5_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h5", 24);
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("jhiTranslate", ctx_r13.errorMessage);
} }
function RateSessionComponent_ng_template_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, RateSessionComponent_ng_template_25_h5_1_Template, 1, 1, "h5", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.errorMessage);
} }
export class RateSessionComponent {
    constructor(ratingService, modalService, eventManager, router, languageService) {
        this.ratingService = ratingService;
        this.modalService = modalService;
        this.eventManager = eventManager;
        this.router = router;
        this.languageService = languageService;
        this.stars = [1, 2, 3, 4, 5];
        this.maxHighLightIndexApp = -1;
        this.maxHighLightIndexCoach = -1;
        this.currentRating = undefined;
        this.errorMessage = 'sessionChat.messages.rateBoth';
    }
    ngOnInit() {
        this.getRating(this.session.id);
    }
    getRating(sessionId) {
        this.ratingService.findBySessionId(sessionId).subscribe(res => {
            this.currentRating = res.body || null;
            this.maxHighLightIndexCoach = this.currentRating ? this.currentRating.rating - 1 : this.maxHighLightIndexCoach;
            this.maxHighLightIndexApp = this.currentRating ? this.currentRating.appRating - 1 : this.maxHighLightIndexApp;
            this.comment = this.currentRating ? this.currentRating.message : this.comment;
            this.eventManager.broadcast("maxHighLightIndexUpdated");
        });
    }
    highlightStarCoach($event, i) {
        this.maxHighLightIndexCoach = i;
    }
    highlightStarApp($event, i) {
        this.maxHighLightIndexApp = i;
    }
    getCommentLength() {
        return !this.comment ? 0 : this.comment.length;
    }
    finishRateSession() {
        if (this.maxHighLightIndexCoach < 0 || this.maxHighLightIndexApp < 0) {
            this.modalService.open(this.ratingAlertModal);
            return;
        }
        let rating = new Rating();
        rating.message = this.comment;
        rating.session.id = this.session.id;
        rating.appRating = this.maxHighLightIndexApp + 1;
        rating.rating = this.maxHighLightIndexCoach + 1;
        rating.user.id = this.session.user.id;
        rating.coach.id = this.session.coachId;
        rating.langKey = this.languageService.getCurrentLanguage();
        this.ratingService.create(rating).subscribe(() => {
            this.modalService.dismissAll();
            this.eventManager.broadcast('ratingModifications');
            if (this.displayingPastSession) {
                this.getRating(this.session.id);
            }
            else {
                this.router.navigate(["/index-user"]).then();
            }
        }, () => {
            console.log('rating cannot be saved.');
        });
    }
    closeAll() {
        this.modalService.dismissAll();
    }
}
RateSessionComponent.ɵfac = function RateSessionComponent_Factory(t) { return new (t || RateSessionComponent)(i0.ɵɵdirectiveInject(i1.RatingService), i0.ɵɵdirectiveInject(i2.NgbModal), i0.ɵɵdirectiveInject(i3.JhiEventManager), i0.ɵɵdirectiveInject(i4.Router), i0.ɵɵdirectiveInject(i5.JhiLanguageService)); };
RateSessionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RateSessionComponent, selectors: [["rate-session"]], viewQuery: function RateSessionComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ratingAlertModal = _t.first);
    } }, decls: 27, vars: 7, consts: [[1, "olha-theme"], [1, "modal-body"], ["icon", "times-circle", 1, "close-icon", 3, "click"], [1, "block", "text-center", "h3-div"], ["jhiTranslate", "sessionChat.header.end"], ["jhiTranslate", "sessionChat.paragraph.howWere", 1, "block", "text-center", "paragraph-div"], [1, "block", "text-center", "h4-div"], ["jhiTranslate", "sessionChat.paragraph.yourCoach"], [1, "rating-stars"], ["type", "hidden", "readonly", "readonly", "name", "another-rating-stars-value", "value", "5", 1, "rating-value"], [1, "rating-stars-container"], ["class", "rating-star", 4, "ngFor", "ngForOf"], ["jhiTranslate", "sessionChat.paragraph.inuka"], ["type", "hidden", "readonly", "readonly", "name", "app-rating-stars-value", "value", "5", 1, "rating-value"], [1, "block", "mb-2"], ["inputAutoDirectionSwitch", "", "rows", "5", "maxlength", "250", 1, "form-control", 3, "ngModel", "placeholder", "ngModelChange"], [1, "counter"], [1, "block", "text-center"], ["type", "button", "jhiTranslate", "sessionChat.button.submitFeedback", 1, "btn", "btn-primary", "align-items-center", "justify-content-center", 3, "click"], ["ratingAlertModal", ""], [1, "rating-star"], ["icon", "star", 3, "ngClass", "click"], [1, "modal-body", "alert-modal"], ["class", "modal-title", 3, "jhiTranslate", 4, "ngIf"], [1, "modal-title", 3, "jhiTranslate"]], template: function RateSessionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "fa-icon", 2);
        i0.ɵɵlistener("click", function RateSessionComponent_Template_fa_icon_click_2_listener() { return ctx.closeAll(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelement(4, "h3", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(5, "div", 5);
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵelement(7, "span", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 8);
        i0.ɵɵelement(9, "input", 9);
        i0.ɵɵelementStart(10, "div", 10);
        i0.ɵɵtemplate(11, RateSessionComponent_div_11_Template, 2, 3, "div", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 6);
        i0.ɵɵelement(13, "span", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 8);
        i0.ɵɵelement(15, "input", 13);
        i0.ɵɵelementStart(16, "div", 10);
        i0.ɵɵtemplate(17, RateSessionComponent_div_17_Template, 2, 3, "div", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 14);
        i0.ɵɵelementStart(19, "textarea", 15);
        i0.ɵɵlistener("ngModelChange", function RateSessionComponent_Template_textarea_ngModelChange_19_listener($event) { return ctx.comment = $event; });
        i0.ɵɵpipe(20, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 16);
        i0.ɵɵtext(22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "div", 17);
        i0.ɵɵelementStart(24, "button", 18);
        i0.ɵɵlistener("click", function RateSessionComponent_Template_button_click_24_listener() { return ctx.finishRateSession(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(25, RateSessionComponent_ng_template_25_Template, 2, 1, "ng-template", null, 19, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("ngForOf", ctx.stars);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngForOf", ctx.stars);
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(20, 5, "sessionChat.placeholder.tellUs"));
        i0.ɵɵproperty("ngModel", ctx.comment);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1("", ctx.getCommentLength(), " / 250");
    } }, directives: [i6.FaIconComponent, i7.JhiTranslateDirective, i8.NgForOf, i9.DefaultValueAccessor, i10.InputAutoDirectionSwitchDirective, i9.MaxLengthValidator, i9.NgControlStatus, i9.NgModel, i8.NgClass, i8.NgIf], pipes: [i11.TranslatePipe], styles: ["[_nghost-%COMP%]  .modal-content{border:none !important;border-radius:20px !important}.modal-body[_ngcontent-%COMP%]{padding:30px !important;position:relative !important}.close-icon[_ngcontent-%COMP%]{position:absolute !important;top:12px !important;right:12px !important;cursor:pointer !important;color:#0a4a3a !important}.h3-div[_ngcontent-%COMP%]{margin-bottom:10px !important}.paragraph-div[_ngcontent-%COMP%]{font-family:\"Open Sans\",sans-serif !important;font-size:18px !important;margin:0 auto 20px auto !important;max-width:327px !important}.h4-div[_ngcontent-%COMP%]{font-family:\"Poppins\",sans-serif !important;font-weight:600 !important;font-size:16px !important;margin-bottom:14px !important}.rating-stars[_ngcontent-%COMP%]   .rating-stars-container[_ngcontent-%COMP%]   .rating-star[_ngcontent-%COMP%]{font-size:34px !important;padding:0 10px !important}.rating-star-hover[_ngcontent-%COMP%]{color:#44a38d}.rating-stars[_ngcontent-%COMP%]{margin-bottom:30px !important}textarea[_ngcontent-%COMP%]{background:#fdfdfd !important;border:1px solid #8a9d98 !important;box-sizing:border-box !important;border-radius:10px !important;padding:16px !important;font-family:\"Open Sans\",sans-serif !important}[_ngcontent-%COMP%]::-moz-placeholder{color:#8a9d98 !important}[_ngcontent-%COMP%]::placeholder{color:#8a9d98 !important}.counter[_ngcontent-%COMP%]{font-family:\"Open Sans\",sans-serif !important;text-align:right !important;padding-top:5px !important}button[_ngcontent-%COMP%]{font-family:\"Poppins\",sans-serif !important}.rating-stars[_ngcontent-%COMP%]{margin-bottom:30px !important}textarea[_ngcontent-%COMP%]{background:#fdfdfd !important;border:1px solid #8a9d98 !important;box-sizing:border-box !important;border-radius:10px !important;padding:16px !important;font-family:\"Open Sans\",sans-serif !important}[_ngcontent-%COMP%]::-moz-placeholder{color:#8a9d98 !important}[_ngcontent-%COMP%]::placeholder{color:#8a9d98 !important}.counter[_ngcontent-%COMP%]{font-family:\"Open Sans\",sans-serif !important;text-align:right !important;padding-top:5px !important}button[_ngcontent-%COMP%]{font-family:\"Poppins\",sans-serif !important}.alert-modal[_ngcontent-%COMP%]{background-color:#fff;overflow-wrap:break-word;border-radius:.3rem;text-align:center}"] });
